<script>
    export default {
        name: 'housingTable',

        props: {
            isCalc: null,
            isParis: null,
            housingEstimate: null,
            parisEstimates: null,
            whereLive: null,
            estimateMessage: null
        },

        data() {
            return {
                estimateMessages: {
                    "oncampus": this.estimateMessage,
                    "offcampus": "Estimate based on recent data for a 2-bedroom apartment in university zip code.",
                    "withfamily": "Estimate for families housing a student at home.",
                }
            }
        }

    }
</script>

<template>
    <div class="a-tableWrapper" >
        <div class="a-tableWrapperSlider">
            <div v-if="isCalc">
                <table v-if="housingEstimate" class="a-table--responsive a-table tf-table tf-table__housing" >
                    <thead>
                    <tr>
                        <th></th>
                        <th>Estimate (per semester)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td v-html="estimateMessages[whereLive]"></td>
                        <td>{{ housingEstimate | toCurrency}}</td>
                    </tr>
                    </tbody>
                </table>
                <p v-else class="tf-incompleteStep">Please complete Step 1 to see a housing estimate.</p>
            </div>
            <div v-else-if="isParis">
                <table class="a-table--responsive a-table tf-table tf-table__housing" >
                    <thead>
                    <tr>
                        <th colspan="2">Per semester estimates based on an average</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>On Campus</td>
                        <td>{{ parisEstimates.oncampus | toCurrency}}</td>
                    </tr>
                    <tr>
                        <td>Off Campus</td>
                        <td>{{ parisEstimates.offcampus | toCurrency}}</td>
                    </tr>
<!--                    <tr>-->
<!--                        <td>With Family</td>-->
<!--                        <td>{{ parisEstimates.withfamily | toCurrency}}</td>-->
<!--                    </tr>-->
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
